import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'

import './images/modal_close.png'

const setupModalEvents = (dialog) => {
  const modalHeadingText = dialog.querySelector('.top-search-client-modal__text')
  const selectPrefectureButtons = dialog.querySelectorAll('.js-more-select-prefecture')
  const prefectureSelectOptions = dialog.querySelectorAll('.top-search-client-modal__prefecture-select-options')
  const backRegionSelectButtons = dialog.querySelectorAll('.js-back-region-select')
  const clientSearchAreaLink = dialog.querySelectorAll('.js-client-search-area-link')

  selectPrefectureButtons.forEach(button => {
    button.addEventListener('click', () => {
      const regionId = button.getAttribute('data-region-id')

      // すべて非表示にしてから…
      prefectureSelectOptions.forEach(option => {
        option.style.display = 'none'
      })
      dialog.querySelectorAll('.top-search-client-modal__select-container').forEach(e => {
        e.style.display = 'none'
      })

      // 選択した地域の文言を反映
      const regionName = button.textContent
      modalHeadingText.textContent = `${regionName}の会社を探す`

      // 対象の region-id を持つ option を表示
      const target = dialog.querySelector(`.top-search-client-modal__prefecture-select-options[data-region-id="${regionId}"]`)
      if (target) {
        target.style.display = 'block'
      }
    })
  })

  clientSearchAreaLink.forEach(link => {
    link.addEventListener('click', (event) => {
      const targetDialog = event.currentTarget.closest('dialog')
      setTimeout(() => {
        targetDialog.close()
      }, 1000)
    })
  })

  backRegionSelectButtons.forEach(button => {
    button.addEventListener('click', () => {
      prefectureSelectOptions.forEach(option => {
        option.style.display = 'none'
      })

      // 文言を元に戻す
      modalHeadingText.textContent = 'お住まいの地域の会社を探す'

      dialog.querySelectorAll('.top-search-client-modal__select-container').forEach(e => {
        e.style.display = 'block'
      })
    })
  })
}

const waitAnimation = (element) => Promise.allSettled(
  Array.from(element.getAnimations()).map(animation => animation.finished)
)

const showGeneralModal = () => {
  const DIALOG_TARGET_SELECTOR = '.js-clientSlectModal-dialog-target'

  const openDialog = (dialog) => {
    if ($(dialog).is(':animated')) return

    setupModalEvents(dialog)
    dialog.showModal()
    dialog.setAttribute('data-activate', 'true')
  }

  const closeDialog = async (dialog) => {
    if ($(dialog).is(':animated')) return

    dialog.setAttribute('data-activate', 'false')
    await waitAnimation(dialog)
    dialog.close()
  }

  $('[data-modal-open-for]').on('click', (event) => {
    const targetDialog = document.querySelector(`#${event.currentTarget.getAttribute('data-modal-open-for')}`)
    openDialog(targetDialog)
  })

  $('[data-modal-close]').on('click', (event) => {
    const targetDialog = event.currentTarget.closest('dialog')
    closeDialog(targetDialog)
  })

  $(DIALOG_TARGET_SELECTOR).on('click', (event) => {
    if (event.target === event.currentTarget) {
      const targetDialog = event.currentTarget
      closeDialog(targetDialog)
    }
  })
}

$(() => {
  showGeneralModal()
})
